import { Paper, PaperProps } from '@material-ui/core'
import clsx from 'clsx'

import useStyles from './EmptyCard.styles'
export const EmptyCard = (props: PaperProps) => {
	const styles = useStyles()

	return <Paper {...props} className={clsx(styles.emptyCard, props.className)}></Paper>
}
